import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Menu, X } from 'lucide-react'

interface NavBarProps {
    onFeedbackClick?: () => void
}

function NavBar({ onFeedbackClick }: NavBarProps = {}) {
    const [showSubscribeModal, setShowSubscribeModal] = useState(false)
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

    return (
        <>
            <nav className="w-full bg-white">
                <div className="max-w-4xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
                    {/* Logo/Brand */}
                    <a href="/" className="flex items-center hover:opacity-80 transition-opacity">
                        <img src="/logo.png" alt="signed" width="184" height="166" className="h-16 w-auto" />
                    </a>

                    {/* Menu Options */}
                    <div className="hidden md:flex items-center gap-6">
                        <Link to="/featured" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                            featured
                        </Link>
                        <Link to="/remote-companies" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                            remote
                        </Link>
                        <Link to="/about" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                            about
                        </Link>
                        <Link to="/helper" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                            helper
                        </Link>
                        <button
                            onClick={() => setShowSubscribeModal(true)}
                            className="px-4 py-2 text-sm bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors"
                        >
                            newsletter
                        </button>
                    </div>

                    {/* Menu Icon (Mobile) */}
                    <button
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                        className="p-2 rounded-lg hover:bg-gray-100 transition-colors md:hidden"
                        aria-label="Menu"
                    >
                        {isMobileMenuOpen ? (
                            <X className="w-5 h-5 text-gray-900" />
                        ) : (
                            <Menu className="w-5 h-5 text-gray-900" />
                        )}
                    </button>
                </div>
            </nav>

            {/* Mobile Menu Dropdown */}
            <div
                className={`md:hidden bg-white border-b border-gray-200 overflow-hidden transition-all duration-300 ease-in-out ${
                    isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0 border-b-0'
                }`}
            >
                <div className="max-w-4xl mx-auto px-4 py-4 flex flex-col gap-4">
                    <Link
                        to="/featured"
                        className="text-sm text-gray-600 hover:text-gray-900 transition-colors py-2"
                        onClick={() => setIsMobileMenuOpen(false)}
                    >
                        featured
                    </Link>
                    <Link
                        to="/remote-companies"
                        className="text-sm text-gray-600 hover:text-gray-900 transition-colors py-2"
                        onClick={() => setIsMobileMenuOpen(false)}
                    >
                        remote
                    </Link>
                    <Link
                        to="/about"
                        className="text-sm text-gray-600 hover:text-gray-900 transition-colors py-2"
                        onClick={() => setIsMobileMenuOpen(false)}
                    >
                        about
                    </Link>
                    <Link
                        to="/helper"
                        className="text-sm text-gray-600 hover:text-gray-900 transition-colors py-2"
                        onClick={() => setIsMobileMenuOpen(false)}
                    >
                        helper
                    </Link>
                    <button
                        onClick={() => {
                            setShowSubscribeModal(true)
                            setIsMobileMenuOpen(false)
                        }}
                        className="px-4 py-2 text-sm bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors"
                    >
                        newsletter
                    </button>
                </div>
            </div>

            {/* Subscribe Modal */}
            {showSubscribeModal && (
                <div
                    className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
                    onClick={() => setShowSubscribeModal(false)}
                >
                    <div
                        className="bg-white rounded-lg shadow-xl relative max-w-[520px] w-full"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Close Button */}
                        <button
                            onClick={() => setShowSubscribeModal(false)}
                            className="absolute -top-3 -right-3 bg-white rounded-full p-2 shadow-lg hover:bg-gray-50 transition-colors z-10"
                            aria-label="Close"
                        >
                            <X className="w-5 h-5 text-gray-600" />
                        </button>

                        {/* Substack Embed */}
                        <iframe
                            src="https://signed.substack.com/embed"
                            width="100%"
                            height="320"
                            style={{ border: '1px solid #EEE', background: 'white', borderRadius: '0.5rem' }}
                            frameBorder="0"
                            scrolling="no"
                            title="Subscribe to Signed newsletter"
                        />
                    </div>
                </div>
            )}
        </>
    )
}

export default NavBar
